import {
  CLEAR_RESET_EMAIL,
  CLEAR_VERIFY_EMAIL,
  CLEAR_VERIFY_USERNAME,
  FETCH_EDIT_PROFILE_FAILED,
  FETCH_EDIT_PROFILE_START,
  FETCH_EDIT_PROFILE_SUC,
  VERIFY_EMAIL_FAILED,
  VERIFY_EMAIL_START,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_USERNAME_FAILED,
  VERIFY_USERNAME_START,
  VERIFY_USERNAME_SUCCESS,
  VERIFY_NAME_START,
  VERIFY_NAME_SUCCESS,
  VERIFY_NAME_FAILED,
  FETCH_USER_DETAILS_START,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  EDIT_USER_DETAILS,
  UPDATE_USER_DETAILS_START,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAILURE,
  UPDATE_USER_COVER_START,
  UPDATE_USER_COVER_SUCCESS,
  UPDATE_USER_COVER_FAILURE,
  UPDATE_USER_PICTURE_START,
  UPDATE_USER_PICTURE_SUCCESS,
  UPDATE_USER_PICTURE_FAILURE,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  EDIT_CHANGE_PASSWORD,
  VERIFY_RESET_EMAIL_FAILURE,
  VERIFY_RESET_TOKEN_START,
  VERIFY_RESET_TOKEN_FAILURE,
  VERIFY_RESET_TOKEN_SUCCESS,
  CLEAR_INVALID_EMAIL,
  VERIFY_RESET_EMAIL_SUCCESS,
  VERIFY_RESET_EMAIL_START,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REGISTER_START,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  GET_LOGIN_DETAILS,
  GET_REGISTER_DETAILS,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  DELETE_ACCOUNT_START,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  EMAIL_VERIFICATION_START,
  EMAIL_VERIFICATION_RESET,
  EMAIL_VERIFICATION_SUCCESS,
  EMAIL_VERIFICATION_FAILURE,
  EMAIL_VERIFICATION_RESEND_START,
  EMAIL_VERIFICATION_RESEND_RESET,
  EMAIL_VERIFICATION_RESEND_SUCCESS,
  EMAIL_VERIFICATION_RESEND_FAILURE,
  NOTIFICATION_STATUS_UPDATE_START,
  NOTIFICATION_STATUS_UPDATE_SUCCESS,
  NOTIFICATION_STATUS_UPDATE_FAILURE,
  GET_FORGOT_PASSWORD_DETAILS,
  FETCH_PAYMENTS_START,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILURE,
  SAVE_BLOCK_USER_START,
  SAVE_BLOCK_USER_SUCCESS,
  SAVE_BLOCK_USER_FAILURE,
  FETCH_BLOCK_USERS_START,
  FETCH_BLOCK_USERS_SUCCESS,
  FETCH_BLOCK_USERS_FAILURE,
  USER_VERIFY_BADGE_STATUS_START,
  USER_VERIFY_BADGE_STATUS_SUCCESS,
  USER_VERIFY_BADGE_STATUS_FAILURE,
  RESET_PASSWORD_START,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  USERNAME_VALIDATION_START,
  USERNAME_VALIDATION_SUCCESS,
  USERNAME_VALIDATION_FAILURE,
  UPDATE_USER_SECURITY_SETTING_START,
  UPDATE_USER_SOCIAL_MEDIA_SETTING_START,
  FETCH_USER_DEVICES_START,
  FETCH_USER_DEVICES_SUCCESS,
  FETCH_USER_DEVICES_FAILURE,
  SAVE_REPORT_USER_START,
  SAVE_REPORT_USER_SUCCESS,
  SAVE_REPORT_USER_FAILURE,
  USER_ONLINE_STATUS_CHANGED,
  UPDATE_USER_NOTIFICATION_SETTING_START,
  UPDATE_USER_NOTIFICATION_SETTING_SUCCESS,
  UPDATE_USER_NOTIFICATION_SETTING_FAILURE,
  UPDATE_USER_PROFILE_VISIBILITY_SETTING_START,
  CLEAR_VERIFY_NAME,
  GOOGLE_SIGNIN_START,
  GOOGLE_SIGNIN_FAILURE,
  GOOGLE_SIGNIN_SUCCESS,
  UPDATE_EMAIL_START,
  UPDATE_EMAIL_END
} from "./ActionConstant";

// Get user details actions.

export function fetchUserDetailsStart(data) {
  return {
    type: FETCH_USER_DETAILS_START,
    data,
  };
}

export function fetchUserDetailsSuccess(data) {
  return {
    type: FETCH_USER_DETAILS_SUCCESS,
    data,
  };
}

export function fetchUserDetailsFailure(error) {
  return {
    type: FETCH_USER_DETAILS_FAILURE,
    error,
  };
}

// Edit user details action.

export function editUserDetails(name, value) {
  return {
    type: EDIT_USER_DETAILS,
    name,
    value,
  };
}

// Update user detatils actions

export function updateUserDetailsStart(data) {
  return {
    type: UPDATE_USER_DETAILS_START,
    data,
  };
}

export function updateUserDetailsSuccess(data) {
  return {
    type: UPDATE_USER_DETAILS_SUCCESS,
    data,
  };
}

export function updateUserDetailsFailure(error) {
  return {
    type: UPDATE_USER_DETAILS_FAILURE,
    error,
  };
}

// Update user cover actions

export function updateUserCoverStart(data) {
  return {
    type: UPDATE_USER_COVER_START,
    data,
  };
}

export function updateUserCoverSuccess(data) {
  return {
    type: UPDATE_USER_COVER_SUCCESS,
    data,
  };
}

export function updateUserCoverFailure(error) {
  return {
    type: UPDATE_USER_COVER_FAILURE,
    error,
  };
}

// Update user picture actions

export function updateUserPictureStart(data) {
  return {
    type: UPDATE_USER_PICTURE_START,
    data,
  };
}

export function updateUserPictureSuccess(data) {
  return {
    type: UPDATE_USER_PICTURE_SUCCESS,
    data,
  };
}

export function updateUserPictureFailure(error) {
  return {
    type: UPDATE_USER_PICTURE_FAILURE,
    error,
  };
}

// Update user detatils actions

export function updateUserSecuritySettingStart(data) {
  return {
    type: UPDATE_USER_SECURITY_SETTING_START,
    data,
  };
}

export function updateUserSocialMediaSettingStart(data) {
  return {
    type: UPDATE_USER_SOCIAL_MEDIA_SETTING_START,
    data,
  };
}

export function updateUserNotificationSettingStart(data) {
  return {
    type: UPDATE_USER_NOTIFICATION_SETTING_START,
    data,
  };
}

export function updateUserNotificationSettingSuccess(data) {
  return {
    type: UPDATE_USER_NOTIFICATION_SETTING_SUCCESS,
    data,
  };
}

export function updateUserNotificationSettingFailure(data) {
  return {
    type: UPDATE_USER_NOTIFICATION_SETTING_FAILURE,
    data,
  };
}

export function updateUserProfileVisibilitySettingStart(data) {
  return {
    type: UPDATE_USER_PROFILE_VISIBILITY_SETTING_START,
    data,
  };
}

// change password edit option

export function editChangePassword(name, value) {
  return {
    type: EDIT_CHANGE_PASSWORD,
    name,
    value,
  };
}

// Change password actions.

export function changePasswordStart(data) {
  return {
    type: CHANGE_PASSWORD_START,
    data,
  };
}

export function changePasswordSuccess(data) {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    data,
  };
}

export function changePasswordFailure(error) {
  return {
    type: CHANGE_PASSWORD_FAILURE,
    error,
  };
}

// Get login Input

export function getLoginInputData(name, value) {
  return {
    type: GET_LOGIN_DETAILS,
    name,
    value,
  };
}

// User login actions.

export function userLoginStart(data) {
  return {
    type: LOGIN_START,
    data,
  };
}

export function userLoginSuccess(data) {
  return {
    type: LOGIN_SUCCESS,
    data,
  };
}

export function userLoginFailure(error) {
  return {
    type: LOGIN_FAILURE,
    error,
  };
}

// google sign in

export function googleSignInStart(data) {
  return {
    type: GOOGLE_SIGNIN_START,
    data
  }
}

export function googleSignInSuccess(data) {
  return {
    type: GOOGLE_SIGNIN_SUCCESS,
    data,
  }
}

export function googleSignInFailure(error) {
  return {
    type: GOOGLE_SIGNIN_FAILURE,
    error,
  }
}

// Get register Input

export function getRegisterInputData(name, value) {
  return {
    type: GET_REGISTER_DETAILS,
    name,
    value,
  };
}

// User Register actions.

export function userRegisterStart(data) {
  return {
    type: REGISTER_START,
    data,
  };
}

export function userRegisterSuccess(data) {
  return {
    type: REGISTER_SUCCESS,
    data,
  };
}

export function userRegisterFailure(error) {
  return {
    type: REGISTER_FAILURE,
    error,
  };
}

// Get forgot password Input

export function getForgotPasswordInputData(name, value) {
  return {
    type: GET_FORGOT_PASSWORD_DETAILS,
    name,
    value,
  };
}

// User FORGOT_PASSWORD actions.

export function forgotPasswordStart(data) {
  return {
    type: FORGOT_PASSWORD_START,
    data,
  };
}

export function forgotPasswordSuccess(data) {
  return {
    type: FORGOT_PASSWORD_SUCCESS,
    data,
  };
}

export function forgotPasswordFailure(error) {
  return {
    type: FORGOT_PASSWORD_FAILURE,
    error,
  };
}

// User Delete Account actions.

export function deleteAccountStart(data) {
  return {
    type: DELETE_ACCOUNT_START,
    data,
  };
}

export function deleteAccountSuccess(data) {
  return {
    type: DELETE_ACCOUNT_SUCCESS,
    data,
  };
}

export function deleteAccountFailure(error) {
  return {
    type: DELETE_ACCOUNT_FAILURE,
    error,
  };
}

// User Delete Account actions.

export function emailVerificationStart(data) {
  return {
    type: EMAIL_VERIFICATION_START,
    data,
  };
}

export function emailVerificationReset(data) {
  return {
    type: EMAIL_VERIFICATION_RESET,
    data,
  };
}

export function emailVerificationSuccess(data) {
  return {
    type: EMAIL_VERIFICATION_SUCCESS,
    data,
  };
}

export function emailVerificationFailure(error) {
  return {
    type: EMAIL_VERIFICATION_FAILURE,
    error,
  };
}

export function emailVerificationResendStart(data) {
  return {
    type: EMAIL_VERIFICATION_RESEND_START,
    data,
  };
}

export function emailVerificationResendReset(data) {
  return {
    type: EMAIL_VERIFICATION_RESEND_RESET,
    data,
  };
}

export function emailVerificationResendSuccess(data) {
  return {
    type: EMAIL_VERIFICATION_RESEND_SUCCESS,
    data,
  };
}

export function emailVerificationResendFailure(error) {
  return {
    type: EMAIL_VERIFICATION_RESEND_FAILURE,
    error,
  };
}

export function notificationStatusUpdateStart(data) {
  return {
    type: NOTIFICATION_STATUS_UPDATE_START,
    data,
  };
}

export function notificationStatusUpdateSuccess(data) {
  return {
    type: NOTIFICATION_STATUS_UPDATE_SUCCESS,
    data,
  };
}

export function notificationStatusUpdateFailure(error) {
  return {
    type: NOTIFICATION_STATUS_UPDATE_FAILURE,
    error,
  };
}

// Get Payments actions.

export function fetchPaymentsStart(data) {
  return {
    type: FETCH_PAYMENTS_START,
    data,
  };
}

export function fetchPaymentsSuccess(data) {
  return {
    type: FETCH_PAYMENTS_SUCCESS,
    data,
  };
}

export function fetchPaymentsFailure(error) {
  return {
    type: FETCH_PAYMENTS_FAILURE,
    error,
  };
}

export function saveBlockUserStart(data) {
  return {
    type: SAVE_BLOCK_USER_START,
    data,
  };
}

export function saveBlockUserSuccess(data) {
  return {
    type: SAVE_BLOCK_USER_SUCCESS,
    data,
  };
}

export function saveBlockUserFailure(error) {
  return {
    type: SAVE_BLOCK_USER_FAILURE,
    error,
  };
}

export function fetchBlockUsersStart(data) {
  return {
    type: FETCH_BLOCK_USERS_START,
    data,
  };
}

export function fetchBlockUsersSuccess(data) {
  return {
    type: FETCH_BLOCK_USERS_SUCCESS,
    data,
  };
}

export function fetchBlockUsersFailure(error) {
  return {
    type: FETCH_BLOCK_USERS_FAILURE,
    error,
  };
}

export function updateVerifyBadgeStatusStart(data) {
  return {
    type: USER_VERIFY_BADGE_STATUS_START,
    data,
  };
}

export function updateVerifyBadgeStatusSuccess(data) {
  return {
    type: USER_VERIFY_BADGE_STATUS_SUCCESS,
    data,
  };
}

export function updateVerifyBadgeStatusFailure(error) {
  return {
    type: USER_VERIFY_BADGE_STATUS_FAILURE,
    error,
  };
}

// User RESET_PASWORD actions.

export function resetPasswordStart(data) {
  return {
    type: RESET_PASSWORD_START,
    data,
  };
}

export function resetPasswordSuccess(data) {
  return {
    type: RESET_PASSWORD_SUCCESS,
    data,
  };
}

export function resetPasswordFailure(error) {
  return {
    type: RESET_PASSWORD_FAILURE,
    error,
  };
}

export function usernameValidationStart(data) {
  return {
    type: USERNAME_VALIDATION_START,
    data,
  };
}

export function usernameValidationSuccess(data) {
  return {
    type: USERNAME_VALIDATION_SUCCESS,
    data,
  };
}

export function usernameValidationFailure(error) {
  return {
    type: USERNAME_VALIDATION_FAILURE,
    error,
  };
}

export function fetchUserDevicesStart(data) {
  return {
    type: FETCH_USER_DEVICES_START,
    data,
  };
}

export function fetchUserDevicesSuccess(data) {
  return {
    type: FETCH_USER_DEVICES_SUCCESS,
    data,
  };
}

export function fetchUserDevicesError(error) {
  return {
    type: FETCH_USER_DEVICES_FAILURE,
    error,
  };
}

//Verify user passwor reset email

export function verifyResetEmailStart(data) {
  return {
    type: VERIFY_RESET_EMAIL_START,
    data,
  };
}

export function verifyResetEmailSuccess(data) {
  return {
    type: VERIFY_RESET_EMAIL_SUCCESS,
    data,
  };
}

export function verifyResetEmailFailure(error) {
  return {
    type: VERIFY_RESET_EMAIL_FAILURE,
    error,
  };
}

export function clearResetEmail() {
  return {
    type: CLEAR_RESET_EMAIL,
  };
}

export function clearInvalidEmail() {
  return {
    type: CLEAR_INVALID_EMAIL,
  };
}

// verify reset token

export function verifyResetTokenStart(data) {
  return {
    type: VERIFY_RESET_TOKEN_START,
    data,
  };
}

export function verifyResetTokenSuccess(data) {
  return {
    type: VERIFY_RESET_TOKEN_SUCCESS,
    data,
  };
}

export function verifyResetTokenFailure(error) {
  return {
    type: VERIFY_RESET_TOKEN_FAILURE,
    error,
  };
}

export function saveReportUserStart(data) {
  return {
    type: SAVE_REPORT_USER_START,
    data,
  };
}

export function saveReportUserSuccess(data) {
  return {
    type: SAVE_REPORT_USER_SUCCESS,
    data,
  };
}

export function saveReportUserFailure(data) {
  return {
    type: SAVE_REPORT_USER_FAILURE,
    data,
  };
}

// verify email

export function verifyEmailStart(data) {
  return {
    type: VERIFY_EMAIL_START,
    data,
  };
}

export function verifyEmailSuccess(data) {
  return {
    type: VERIFY_EMAIL_SUCCESS,
    data,
  };
}

export function verifyEmailFailed(error) {
  return {
    type: VERIFY_EMAIL_FAILED,
    error,
  };
}

export function clearVerifyEmail() {
  return {
    type: CLEAR_VERIFY_EMAIL,
  };
}

// verify username

export function verifyUsernameStart(data) {
  return {
    type: VERIFY_USERNAME_START,
    data,
  };
}

export function verifyUsernameSuccess(data) {
  return {
    type: VERIFY_USERNAME_SUCCESS,
    data,
  };
}

export function verifyUsernameFailed(error) {
  return {
    type: VERIFY_USERNAME_FAILED,
    error,
  };
}

export function clearVerifyUsername() {
  return {
    type: CLEAR_VERIFY_USERNAME,
  };
}

// verify name

export function verifyNameStart(data) {
  return {
    type: VERIFY_NAME_START,
    data,
  };
}

export function verifyNameSuccess(data) {
  return {
    type: VERIFY_NAME_SUCCESS,
    data,
  };
}

export function verifyNameFailed(error) {
  return {
    type: VERIFY_NAME_FAILED,
    error,
  };
}

export function clearVerifyName() {
  return {
    type: CLEAR_VERIFY_NAME,
  };
}

export function fetchEditProfileStart() {
  return {
    type: FETCH_EDIT_PROFILE_START,
  };
}

export function fetchEditProfileSuc(data) {
  return {
    type: FETCH_EDIT_PROFILE_SUC,
    data,
  };
}

export function fetchEditProfileFailed(error) {
  return {
    type: FETCH_EDIT_PROFILE_FAILED,
    error,
  };
}

export function userOnlineStatusChanged(data) {
  return {
    type: USER_ONLINE_STATUS_CHANGED,
    data
  }
}
////// update emnail 
export function update_email_start(data) {
  return {
    type: UPDATE_EMAIL_START,
    data,
  };
}

export function update_email_end(data) {
  return {
    type: UPDATE_EMAIL_END
  };
}
